import React, { useEffect, useState, Fragment } from 'react';
import { PageHeader } from '../../../Common';
import services from '../services';
import authService from '../../Common/services';
import MessageModal from '../../../UI/Modal/MessageModal';
import { LoadingSpinerComponent } from '../../../Common/loader';
import { trackPromise } from 'react-promise-tracker';
import groupService from '../../Group/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import Joi from '@hapi/joi';
import { SessionTimeConfigSchemaObject } from '../SectionTimeConfigSchema';
import { validate } from '../../Common';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import tokenService from '../../../Common/tokenDecoder';
import { MultiSelect } from '../../../Common/multiSelect';

const screenCode = 'SESSIONTIMECONFIGURATION';
const HOURS = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, '0'));
const MINUTES = Array.from({ length: 60 }, (_, i) => String(i).padStart(2, '0'));

export function SessionTimeConfigAddEdit(props) {
    const [groups, setGroups] = useState([]);
    const [divisions, setDivisions] = useState({});
    const [menuCodes, setMenuCodes] = useState({});
    const [filteredEstates, setFilteredEstates] = useState({});
    const [multipleEstates, setMultipleEstates] = useState({});
    const [divisionEstateMap, setDivisionEstateMap] = useState({});
    const [errors, setErrors] = useState({});
    const [selectedEstates, setSelectedEstates] = useState([]);
    const [selectedDivisions, setSelectedDivisions] = useState([]);
    const [selectedMenuCodes, setSelectedMenuCodes] = useState([]);
    const [isTableHidden, setIsTableHidden] = useState(true);
    const [configDetails, setConfigDetails] = useState([]);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: 'Success',
        disciption: 'Save success',
    });
    const [formValue, setFormValue] = useState({
        groupID: '0',
        estate: [],
        divisionID: [],
        menuCode: '0',
        session: '0',
        startTime: '',
        endTime: '',
    });
    const [isFactorySelected, setIsFactorySelected] = useState(false);
    const [isEstateSelected, setIsEstateSelected] = useState(false);
    const isPluckerCollectionLabel = labelOrValue =>
        String(labelOrValue || '').toUpperCase().includes('PLUCKER_COLLECTION');

    useEffect(() => {
        trackPromise(getPermissions());
    }, []);

    useEffect(() => {
        if (formValue.groupID !== '0') {
            getEstatesForDropdown();
        }
    }, [formValue.groupID]);

    useEffect(() => {
        if (selectedEstates.length > 0) {
            getDivisionsForDropDown();
            getMenuCodesForDropDown();
        } else {
            setDivisions({});
            setDivisionEstateMap({});
            setMenuCodes({});
            setSelectedDivisions([]);
            setSelectedMenuCodes([]);
            setFormValue(prev => ({ ...prev, divisionID: [] }));
        }
    }, [selectedEstates]);

    useEffect(() => {
        const selectedEstateIDs = new Set(selectedEstates.map(o => String(o.value)));
        const filtered = selectedDivisions.filter(o => {
            const relatedEstateID =
                o.estateID !== undefined
                    ? String(o.estateID)
                    : String(divisionEstateMap[o.value]);
            return selectedEstateIDs.has(relatedEstateID);
        });
        if (filtered.length !== selectedDivisions.length) {
            setSelectedDivisions(filtered);
            setFormValue(prev => ({ ...prev, divisionID: filtered.map(o => o.value) }));
            setErrors(prev => ({ ...prev, divisionID: undefined }));
        }
    }, [divisionEstateMap, selectedEstates]);

    useEffect(() => {
        setFormValue(prev => ({
            ...prev,
            divisionID: [],
            menuCode: '0',
            session: '0',
            startTime: '',
            endTime: '',
        }));
    }, [formValue.estate]);

    useEffect(() => {
        setFormValue(prev => ({
            ...prev,
            menuCode: '0',
            session: '0',
            startTime: '',
            endTime: '',
        }));
    }, [formValue.divisionID]);

    useEffect(() => {
        setFormValue(prev => ({
            ...prev,
            session: '0',
            startTime: '',
            endTime: '',
        }));
    }, [formValue.menuCode]);

    useEffect(() => {
        setFormValue(prev => ({
            ...prev,
            startTime: '',
            endTime: '',
        }));
    }, [formValue.session]);

    // useEffect(() => {
    //     setFormValue(prev => ({
    //         ...prev,
    //         endTime: '',
    //     }));
    // }, [formValue.startTime]);

    useEffect(() => {
        const isFactoryLabel = labelOrValue => {
            const s = String(labelOrValue || '').toLowerCase();
            return s === 'factory' || s.includes(' factory') || s.includes('factory ') || s === 'factory';
        };
        const isEstateLabel = labelOrValue => {
            const s = String(labelOrValue || '').toLowerCase();
            return s === 'estate' || s.includes(' estate') || s.includes('estate ') || s === 'estate';
        };

        const foundFactory = selectedEstates.some(o => isFactoryLabel(o.label) || isFactoryLabel(o.value));
        const foundEstate = selectedEstates.some(o => isEstateLabel(o.label) || isEstateLabel(o.value));
        const foundPluckerCollection = selectedMenuCodes.some(
            o => isPluckerCollectionLabel(o.label) || isPluckerCollectionLabel(o.value)
        );

        setIsFactorySelected(foundFactory);
        setIsEstateSelected(foundEstate);

        if (foundFactory && foundEstate) {
            const filtered = selectedEstates.filter(o => !(isEstateLabel(o.label) || isEstateLabel(o.value)));
            setSelectedEstates(filtered);
            setFormValue(prev => ({ ...prev, estate: filtered.map(o => o.value) }));
        }

        if (foundFactory && !foundPluckerCollection) {
            setSelectedDivisions([]);
            setDivisions({});
            setDivisionEstateMap({});
            setFormValue(prev => ({ ...prev, divisionID: [], session: '0' }));
            setErrors(prev => ({ ...prev, divisionID: undefined, session: undefined }));
        }
    }, [selectedEstates, selectedMenuCodes]);

    function normalizeTimeValue(timeValue) {
        if (timeValue === null || timeValue === undefined || String(timeValue).trim() === '') return '';
        const match = String(timeValue).match(/^(\d{1,2}):(\d{1,2})/);
        if (!match) return '';
        const hour = String(parseInt(match[1], 10)).padStart(2, '0');
        const minute = String(parseInt(match[2], 10)).padStart(2, '0');
        return `${hour}:${minute}`;
    }

    function getTimeParts(timeValue) {
        const normalized = normalizeTimeValue(timeValue);
        if (!normalized) return { hour: '', minute: '' };   // unset, not "00"
        const [hour, minute] = normalized.split(':');
        return { hour, minute };
    }

    function getMinutesFromTime(timeValue) {
        const { hour, minute } = getTimeParts(timeValue);
        return parseInt(hour, 10) * 60 + parseInt(minute, 10);
    }

    function handleTimeChange(fieldName, part, value) {
        setFormValue(prev => {
            const current = getTimeParts(prev[fieldName]);
            const hour = part === 'hour' ? value : (current.hour || '00');
            const minute = part === 'minute' ? value : (current.minute || '00');
            return { ...prev, [fieldName]: `${hour}:${minute}` };
        });
        setErrors(prev => ({ ...prev, [fieldName]: undefined }));
    }

    function renderTimeSelect(fieldName, labelId) {
        const parts = getTimeParts(formValue[fieldName]);
        return (
            <Box display="flex" alignItems="center" gap={1}>
                <Select
                    fullWidth
                    displayEmpty
                    labelId={labelId}
                    value={parts.hour}
                    onChange={e => handleTimeChange(fieldName, 'hour', e.target.value)}
                >
                    <MenuItem value="" disabled>HH</MenuItem>
                    {HOURS.map(h => <MenuItem key={h} value={h}>{h}</MenuItem>)}
                </Select>
                <Select
                    fullWidth
                    displayEmpty
                    value={parts.minute}
                    onChange={e => handleTimeChange(fieldName, 'minute', e.target.value)}
                >
                    <MenuItem value="" disabled>MM</MenuItem>
                    {MINUTES.map(m => <MenuItem key={m} value={m}>{m}</MenuItem>)}
                </Select>
            </Box>
        );
    }

    const handleChange = e => {
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }

        const { name, value } = e.target;
        setErrors(prev => {
            const err = { ...prev };
            delete err[name];
            return err;
        });

        setFormValue(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleEstateChange = selectedOptions => {
        const isFactoryLabel = labelOrValue => {
            const s = String(labelOrValue || '').toLowerCase();
            return s === 'factory' || s.includes(' factory') || s.includes('factory ');
        };
        const isEstateLabel = labelOrValue => {
            const s = String(labelOrValue || '').toLowerCase();
            return s === 'estate' || s.includes(' estate') || s.includes('estate ');
        };

        const hasFactory = selectedOptions.some(o => isFactoryLabel(o.label) || isFactoryLabel(o.value));
        const hasEstate = selectedOptions.some(o => isEstateLabel(o.label) || isEstateLabel(o.value));

        if (hasFactory && hasEstate) {
            setErrors(prev => ({ ...prev, estate: 'Cannot select Estate together with Factory. Choose only one type.' }));
            return;
        }

        setSelectedEstates(selectedOptions);
        setFormValue(prev => ({ ...prev, estate: selectedOptions.map(o => o.value) }));
        setErrors(prev => ({ ...prev, estate: undefined }));
    };

    const handleEstateSelectAll = selectAll => {
        if (selectAll) {
            const all = Object.entries(filteredEstates).map(([value, label]) => ({ value, label }));
            setSelectedEstates(all);
            setFormValue(prev => ({ ...prev, estate: all.map(o => o.value) }));
        } else {
            setSelectedEstates([]);
            setFormValue(prev => ({ ...prev, estate: [], divisionID: [] }));
        }
        setErrors(prev => ({ ...prev, estate: undefined }));
    };

    const handleEstateClear = () => {
        setSelectedEstates([]);
        setSelectedDivisions([]);
        setFormValue(prev => ({ ...prev, estate: [], divisionID: [] }));
        setErrors(prev => ({ ...prev, estate: undefined }));
    };

    const handleDivisionChange = selectedOptions => {
        setSelectedDivisions(selectedOptions);
        setFormValue(prev => ({ ...prev, divisionID: selectedOptions.map(o => o.value) }));
        setErrors(prev => ({ ...prev, divisionID: undefined }));
    };

    const handleDivisionSelectAll = selectAll => {
        if (selectAll) {
            const all = Object.entries(divisions).map(([value, label]) => ({
                value,
                label,
                estateID: divisionEstateMap[value],
            }));
            setSelectedDivisions(all);
            setFormValue(prev => ({ ...prev, divisionID: all.map(o => o.value) }));
        } else {
            setSelectedDivisions([]);
            setFormValue(prev => ({ ...prev, divisionID: [] }));
        }
        setErrors(prev => ({ ...prev, divisionID: undefined }));
    };

    const handleDivisionClear = () => {
        setSelectedDivisions([]);
        setFormValue(prev => ({ ...prev, divisionID: [] }));
        setErrors(prev => ({ ...prev, divisionID: undefined }));
    };

    const handleAdd = e => {
        e.preventDefault();

        const selectedMenuLabel = formValue.menuCode !== '0' ? menuCodes[formValue.menuCode] : '';
        const isPluckerCollectionSelected = isPluckerCollectionLabel(selectedMenuLabel) || isPluckerCollectionLabel(formValue.menuCode);
        const isSessionEnabled = isPluckerCollectionSelected;
        const isDivisionEnabled = selectedEstates.length > 0 && (!isFactorySelected);
        const schema = Joi.object({
            ...SessionTimeConfigSchemaObject,
            session: isSessionEnabled
                ? SessionTimeConfigSchemaObject.session
                : Joi.any().optional().allow('', null, 0),
            divisionID: isDivisionEnabled
                ? Joi.array().min(1).required().label('Division').messages({
                    'array.min': 'At least one Collection Point is required',
                    'any.required': 'Collection Point is required',
                })
                : Joi.array().optional(),
        }).options({ allowUnknown: true });

        const payload = {
            ...formValue,
            estate: selectedEstates.map(o => o.value),
            divisionID: selectedDivisions.map(o => o.value),
            menuCode: formValue.menuCode !== '0' ? [formValue.menuCode] : [],
            session: isSessionEnabled && formValue.session !== '0' ? parseInt(formValue.session) : undefined,
            startTime: normalizeTimeValue(formValue.startTime),
            endTime: normalizeTimeValue(formValue.endTime),
        };

        const errorMessages = validate(schema, payload);
        setErrors(errorMessages || {});
        if (errorMessages && Object.keys(errorMessages).length > 0) return;

        // if (formValue.startTime && formValue.endTime && getMinutesFromTime(formValue.endTime) <= getMinutesFromTime(formValue.startTime)) {
        //     setErrors(prev => ({ ...prev, endTime: 'End Time must be after Start Time.' }));
        //     return;
        // }

        const divisionsToUse =
            selectedDivisions.length > 0
                ? selectedDivisions
                : isDivisionEnabled
                    ? Object.entries(divisionEstateMap).map(([divID, estateID]) => ({
                        value: divID,
                        label: divisions[divID] || 'Unknown Division',
                        estateID,
                    }))
                    : selectedEstates.map(estate => ({
                        value: '0',
                        label: 'All Divisions',
                        estateID: estate.value,
                    }));

        if (isDivisionEnabled && divisionsToUse.length === 0) {
            setErrors(prev => ({
                ...prev,
                divisionID: 'No divisions available for the selected factories.',
            }));
            return;
        }

        const newRows = divisionsToUse.map(option => {
            const estateID = option.estateID || divisionEstateMap[option.value];
            const estateLabel =
                filteredEstates[estateID] ||
                Object.entries(filteredEstates).find(([k]) => k === String(estateID))?.[1] ||
                'Unknown Factory';
            const menuName = formValue.menuCode !== '0' ? menuCodes[formValue.menuCode] : '-';
            return {
                groupID: formValue.groupID,
                estateID,
                estateLabel,
                divisionID: option.value,
                divisionLabel: option.label || divisions[option.value] || 'Unknown Division',
                menuName: menuName,
                menuCode: formValue.menuCode,
                session: formValue.session,
                startTime: formValue.startTime,
                endTime: formValue.endTime,
            };
        });

        const isSame = (a, b) => {
            return (
                String(a.divisionID) === String(b.divisionID) &&
                String(a.session) === String(b.session) &&
                String(a.menuCode) === String(b.menuCode) &&
                String(a.estateID) === String(b.estateID)
            );
        };

        const uniqueRows = newRows.filter(row => !configDetails.some(existing => isSame(existing, row)));
        const duplicateCount = newRows.length - uniqueRows.length;

        if (uniqueRows.length > 0) {
            setConfigDetails(prev => [...prev, ...uniqueRows]);
            setIsTableHidden(false);
        }

        if (duplicateCount > 0) {
            setMessageModel({
                hidden: false,
                type: 'Warning',
                disciption:
                    uniqueRows.length === 0
                        ? 'Selected configuration(s) already exist and were not added.'
                        : `${duplicateCount} duplicate record(s) were skipped.`,
            });
            setTimeout(() => setMessageModel(prev => ({ ...prev, hidden: true })), 4000);
        }
    };

    async function handleSave(e) {
        e.preventDefault();
        if (configDetails.length === 0) {
            setMessageModel({ hidden: false, type: 'Error', disciption: 'No records to save.' });
            setTimeout(() => setMessageModel(prev => ({ ...prev, hidden: true })), 3000);
            return;
        }

        const savePayload = configDetails.map(item => ({
            groupID: parseInt(item.groupID),
            factoryID: parseInt(item.estateID),
            divisionID: parseInt(item.divisionID),
            menuCode: parseInt(item.menuCode),
            menuName: item.menuName,
            sessionID: parseInt(item.session),
            startTime: item.startTime.length === 5 ? item.startTime + ':00' : item.startTime,
            endTime: item.endTime.length === 5 ? item.endTime + ':00' : item.endTime,
            createdBy: parseInt(tokenService.getUserIDFromToken()),
        }));

        const response = await trackPromise(services.saveSectionTimeConfiguration(savePayload));

        if (response.statusCode === 'Success') {
            setMessageModel({ hidden: false, type: 'Success', disciption: response.message || 'Saved successfully.' });
            setTimeout(() => {
                setMessageModel(prev => ({ ...prev, hidden: true }));
                props.history.push('/SessionTimeConfiguration');
            }, 2500);
            return;
        }

        setMessageModel({ hidden: false, type: 'Error', disciption: response.message || 'Save failed.' });
        setTimeout(() => setMessageModel(prev => ({ ...prev, hidden: true })), 4000);
    }

    function handleDeleteRow(rowIndex) {
        const updated = configDetails.filter((_, i) => i !== rowIndex);
        setConfigDetails(updated);
        if (updated.length === 0) setIsTableHidden(true);
    }

    function clearForm() {
        const token = tokenService.getUserDetailsFromTokenV2();
        const defaultGroupID = token.groupID || '0';

        let defaultSelectedEstates = [];
        let defaultEstateIDs = [];
        if (token.operationEntityID) {
            const estateIDStr = String(token.operationEntityID);
            const label = multipleEstates[estateIDStr] || filteredEstates[estateIDStr] || `Operation Entity ${estateIDStr}`;
            defaultSelectedEstates = [{ value: estateIDStr, label }];
            defaultEstateIDs = [estateIDStr];
        }

        setConfigDetails([]);
        setSelectedEstates(defaultSelectedEstates);
        setSelectedDivisions([]);
        setIsTableHidden(true);
        setErrors({});
        setFormValue({
            groupID: defaultGroupID,
            estate: defaultEstateIDs,
            divisionID: [],
            menuCode: '0',
            session: '0',
            startTime: '',
            endTime: '',
        });
    }

    function modalDismissHandler() {
        setMessageModel(prev => ({ ...prev, hidden: true }));
    }

    async function getPermissions() {
        try {
            const permissions = await authService.getPermissionsByScreen(screenCode);
            const isAuthorized = permissions.find(p => p.permissionCode === 'ADDEDITSESSIONTIMECONFIGURATION');
            if (!isAuthorized) {
                props.history.push('/unauthorized');
                return;
            }

            const isGroupFilterEnabled = permissions.find(p => p.permissionCode === 'GROUPDROPDOWN');
            const isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode === 'OPERATIONENTITYDROPDOWN');

            setPermissions({
                isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
                isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined,
            });

            const token = tokenService.getUserDetailsFromTokenV2();
            let estateArray = {};
            if (token.operationEntities && token.operationEntities.length > 0) {
                token.operationEntities.forEach(item => {
                    estateArray[item.OperationEntityID] = item.OperationEntityName;
                });
            }
            setMultipleEstates(estateArray);

            let defaultSelectedEstates = [];
            let defaultEstateIDs = [];
            if (token.operationEntityID) {
                const estateIDStr = String(token.operationEntityID);
                const label = estateArray[estateIDStr] || `Operation Entity ${estateIDStr}`;
                defaultSelectedEstates = [{ value: estateIDStr, label }];
                defaultEstateIDs = [estateIDStr];
            }
            setSelectedEstates(defaultSelectedEstates);

            setFormValue(prev => {
                const updated = { ...prev, groupID: token.groupID || '0', estate: defaultEstateIDs };
                delete updated.estateID;
                return updated;
            });

            await getAllGroups();
        } catch (error) {
            setMessageModel({
                hidden: false,
                type: 'Error',
                disciption: 'Failed to load permissions.',
            });
        }
    }

    async function getAllGroups() {
        const data = await groupService.getGroupsForDropdown();
        setGroups(data);
    }

    async function getEstatesForDropdown() {
        try {
            const apiEstates = await services.getEstatesByGroupID(formValue.groupID);
            const apiEstatesObject = {};
            apiEstates.forEach((name, index) => {
                if (name !== null && name !== undefined) {
                    apiEstatesObject[String(index)] = name;
                }
            });

            let estatesToShow = {};
            if (Object.keys(multipleEstates).length === 0) {
                estatesToShow = apiEstatesObject;
            } else {
                estatesToShow = Object.keys(apiEstatesObject).reduce((acc, key) => {
                    if (multipleEstates[key]) {
                        acc[key] = multipleEstates[key];
                    }
                    return acc;
                }, {});
            }

            setFilteredEstates(estatesToShow);

            setSelectedEstates(prev => {
                const valid = prev.filter(e => estatesToShow[e.value]);
                if (valid.length !== prev.length) {
                    if (valid.length === 0) {
                        setSelectedDivisions([]);
                        setDivisions({});
                        setDivisionEstateMap({});
                    }
                }
                return valid;
            });

            setFormValue(prev => {
                const validEstates = prev.estate.filter(e => estatesToShow[e]);
                if (validEstates.length !== prev.estate.length) {
                    return { ...prev, estate: validEstates, divisionID: validEstates.length === 0 ? [] : prev.divisionID };
                }
                return prev;
            });
        } catch (error) {
            setErrors(prev => ({ ...prev, estate: 'Failed to load factories.' }));
        }
    }

    async function getDivisionsForDropDown() {
        let combinedDivisions = {};
        let divEstateMap = {};
        for (const estate of selectedEstates) {
            if (estate.value && estate.value !== '0') {
                const data = await services.getDivisionByEstateID(estate.value);
                combinedDivisions = { ...combinedDivisions, ...data };
                Object.keys(data).forEach(divID => {
                    divEstateMap[divID] = estate.value;
                });
            }
        }
        setDivisions(combinedDivisions);
        setDivisionEstateMap(divEstateMap);
    }

    async function getMenuCodesForDropDown() {
        const getMenuCodeValue = (item, fallback) => {
            if (item && typeof item === 'object') {
                return String(
                    item.menuCode ??
                    item.menuCodeID ??
                    item.menuCodeNo ??
                    item.code ??
                    item.id ??
                    fallback
                );
            }
            return String(item ?? fallback);
        };

        const getMenuCodeLabel = item => {
            if (item === null || item === undefined) return '';

            if (typeof item === 'string' || typeof item === 'number') {
                return String(item);
            }

            if (typeof item === 'object') {
                return (
                    item.menuName ||
                    item.menuCodeName ||
                    item.name ||
                    item.description ||
                    item.menuCode ||
                    item.menuCodeID ||
                    ''
                );
            }

            return String(item);
        };

        const formatMenuCodeLabel = (code, item) => {
            if (item === null || item === undefined) return '';

            if (typeof item === 'string' || typeof item === 'number') {
                return `${item}`;
            }

            if (typeof item === 'object') {
                const menuName =
                    item.menuName ||
                    item.menuCodeName ||
                    item.name ||
                    item.description ||
                    item.menuCode ||
                    item.menuCodeID ||
                    '';
                return `${typeof menuName === 'string' || typeof menuName === 'number' ? menuName : JSON.stringify(menuName)}`;
            }

            return `${String(item)}`;
        };

        try {
            let combinedMenuCodes = {};
            for (const estate of selectedEstates) {
                if (estate.value && estate.value !== '0') {
                    const data = await services.getMenuCode(estate.value);
                    if (Array.isArray(data)) {
                        data.forEach((item, index) => {
                            const code = getMenuCodeValue(item, index + 1);
                            const label = formatMenuCodeLabel(code, item);
                            if (label) {
                                combinedMenuCodes[code] = label;
                            }
                        });
                    } else if (data && typeof data === 'object') {
                        Object.entries(data).forEach(([key, value]) => {
                            const code = String(key);
                            const labelValue = getMenuCodeLabel(value);
                            const label = labelValue ? `${labelValue}` : '';
                            if (label) {
                                combinedMenuCodes[code] = label;
                            }
                        });
                    }
                }
            }
            setMenuCodes(combinedMenuCodes);
        } catch (error) {
            setErrors(prev => ({ ...prev, menuCode: 'Failed to load menu codes.' }));
        }
    }

    function generateDropDownMenu(data) {
        return Object.entries(data || {}).map(([key, value]) => (
            <MenuItem key={key} value={key}>
                {value}
            </MenuItem>
        ));
    }

    const operationItems = Object.entries(filteredEstates).map(([value, label]) => ({ value, label }));
    const isFactoryLabel = labelOrValue => {
        const s = String(labelOrValue || '').toLowerCase();
        return s === 'factory' || s.includes(' factory') || s.includes('factory ');
    };
    const isEstateLabel = labelOrValue => {
        const s = String(labelOrValue || '').toLowerCase();
        return s === 'estate' || s.includes(' estate') || s.includes('estate ');
    };
    let operationItemsFiltered = operationItems;
    if (isEstateSelected) {
        operationItemsFiltered = operationItems.filter(o => !isFactoryLabel(o.label) && !isFactoryLabel(o.value));
    } else if (isFactorySelected) {
        operationItemsFiltered = operationItems.filter(o => !isEstateLabel(o.label) && !isEstateLabel(o.value));
    }
    const selectedMenuLabel = formValue.menuCode !== '0' ? menuCodes[formValue.menuCode] : '';
    const isPluckerCollectionSelected = isPluckerCollectionLabel(selectedMenuLabel) || isPluckerCollectionLabel(formValue.menuCode);

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Add Session Time Configuration"
                            isButtonEnable={true}
                            buttonText="Back to Listing"
                            path="/SessionTimeConfiguration"
                        />
                        <form onSubmit={handleAdd}>
                            <div className="card-body">
                                <div className="form-group row">

                                    {/* Group */}
                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={formValue.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={handleChange}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors['groupID'] && (
                                            <FormHelperText error>{errors['groupID']}</FormHelperText>
                                        )}
                                    </div>

                                    {/* Factory (Operation Entity) */}
                                    <div className="col-md-3 pb-1">
                                        <MultiSelect
                                            items={operationItemsFiltered}
                                            selectedValues={selectedEstates}
                                            label="Operation Entity *"
                                            placeholder="Select Operation Entities"
                                            selectAllLabel="Select All Operation Entities"
                                            noOptionsText="No Operation Entities"
                                            limitTags={3}
                                            onToggleOption={handleEstateChange}
                                            onSelectAll={handleEstateSelectAll}
                                            onClearOptions={handleEstateClear}
                                            getOptionLabel={option => option.label}
                                            isDisabled={!permissionList.isOperationEntityFilterEnabled}
                                        />
                                        {errors['estate'] && (
                                            <FormHelperText error>{errors['estate']}</FormHelperText>
                                        )}
                                    </div>

                                    {/* Division */}
                                    <div className="col-md-3 pb-1">
                                        <MultiSelect
                                            items={Object.entries(divisions).map(([value, label]) => ({
                                                value,
                                                label,
                                                estateID: divisionEstateMap[value],
                                            }))}
                                            selectedValues={selectedDivisions}
                                            label="Collection Point *"
                                            placeholder="Select Collection Points"
                                            selectAllLabel="Select All Collection Points"
                                            noOptionsText="No Collection Points"
                                            limitTags={3}
                                            onToggleOption={handleDivisionChange}
                                            onSelectAll={handleDivisionSelectAll}
                                            onClearOptions={handleDivisionClear}
                                            getOptionLabel={option => option.label}
                                            isDisabled={isFactorySelected}
                                        />
                                        {errors['divisionID'] && (
                                            <FormHelperText error>{errors['divisionID']}</FormHelperText>
                                        )}
                                    </div>

                                    {/* Menu Code */}
                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="menuCode">Menu Code *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="menuCode"
                                            id="menuCode"
                                            name="menuCode"
                                            value={formValue.menuCode}
                                            onChange={handleChange}
                                        >
                                            <MenuItem value="0">--Select Menu Code--</MenuItem>
                                            {generateDropDownMenu(menuCodes)}
                                        </Select>
                                        {errors['menuCode'] && (
                                            <FormHelperText error>{errors['menuCode']}</FormHelperText>
                                        )}
                                    </div>

                                    {/* Session */}
                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="session">Session *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="session"
                                            id="session"
                                            name="session"
                                            value={formValue.session}
                                            onChange={handleChange}
                                            disabled={!isPluckerCollectionSelected}
                                        >
                                            <MenuItem value="0">--Select Session--</MenuItem>
                                            <MenuItem value="1">Session 1</MenuItem>
                                            <MenuItem value="2">Session 2</MenuItem>
                                            <MenuItem value="3">Session 3</MenuItem>
                                        </Select>
                                        {errors['session'] && (
                                            <FormHelperText error>{errors['session']}</FormHelperText>
                                        )}
                                    </div>

                                    {/* Start Time */}
                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="startTimeLabel">Start Time *</InputLabel>
                                        {renderTimeSelect('startTime', 'startTimeLabel')}
                                        {errors['startTime'] && (
                                            <FormHelperText error>{errors['startTime']}</FormHelperText>
                                        )}
                                    </div>

                                    {/* End Time */}
                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="endTimeLabel">End Time *</InputLabel>
                                        {renderTimeSelect('endTime', 'endTimeLabel')}
                                        {errors['endTime'] && (
                                            <FormHelperText error>{errors['endTime']}</FormHelperText>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </form>

                        {/* Add & Clear — bottom-right footer */}
                        <div className="card-footer">
                            <div className="d-flex justify-content-end">
                                {configDetails.length === 0 && (
                                    <input
                                        type="button"
                                        className="btn btn-warning mr-2"
                                        value="Clear"
                                        onClick={clearForm}
                                    />
                                )}
                                <input
                                    type="button"
                                    className="btn btn-primary"
                                    value="Add"
                                    onClick={handleAdd}
                                />
                            </div>
                        </div>

                        {/* Results Table */}
                        <Box display="flex" justifyContent="flex-end" p={2} hidden={isTableHidden}>
                            <TableContainer component={Paper}>
                                <Table aria-label="session time configuration table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center" style={{ fontWeight: 'bold' }}>
                                                Operation Entity
                                            </TableCell>
                                            <TableCell align="center" style={{ fontWeight: 'bold' }}>
                                                Collection Point
                                            </TableCell>
                                            <TableCell align="center" style={{ fontWeight: 'bold' }}>
                                                Menu Name
                                            </TableCell>
                                            <TableCell align="center" style={{ fontWeight: 'bold' }}>
                                                Session
                                            </TableCell>
                                            <TableCell align="center" style={{ fontWeight: 'bold' }}>
                                                Start Time
                                            </TableCell>
                                            <TableCell align="center" style={{ fontWeight: 'bold' }}>
                                                End Time
                                            </TableCell>
                                            <TableCell align="center" style={{ fontWeight: 'bold' }}>
                                                Action
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {configDetails.map((row, index) => (
                                            <TableRow key={index}>
                                                <TableCell align="center">{row.estateLabel}</TableCell>
                                                <TableCell align="center">{row.divisionLabel && row.divisionLabel !== 'All Divisions' ? row.divisionLabel : '-'}</TableCell>
                                                <TableCell align="center">{row.menuName}</TableCell>
                                                <TableCell align="center">{row.session && row.session !== '0' ? `Session ${row.session}` : '-'}</TableCell>
                                                <TableCell align="center">{row.startTime}</TableCell>
                                                <TableCell align="center">{row.endTime}</TableCell>
                                                <TableCell align="center">
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => handleDeleteRow(index)}
                                                        title="Delete"
                                                        aria-label="Delete"
                                                    >
                                                        <DeleteOutlineIcon color="secondary" fontSize="small" />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>

                                <div className="card-footer">
                                    <div className="d-flex justify-content-end">
                                        <input
                                            type="button"
                                            className="btn btn-warning mr-2"
                                            value="Clear"
                                            onClick={clearForm}
                                        />
                                        <input
                                            type="button"
                                            className="btn btn-primary"
                                            value="Save"
                                            onClick={handleSave}
                                        />
                                    </div>
                                </div>
                            </TableContainer>
                        </Box>
                    </div>
                </div>
            </div>

            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}
